import React, { useEffect, useState, useRef } from 'react';
import { 
  Box, 
  Button, 
  Typography, 
  Stack, 
  Card, 
  CardContent, 
  Container,
  Grid,
  Paper,
  Chip,
  Tooltip,
  Fade,
  Zoom,
  Divider,
  Avatar,
  LinearProgress
} from '@mui/material';
import { MapContainer, TileLayer, Marker, Popup, Tooltip as MapTooltip } from 'react-leaflet';
import L from 'leaflet';
import { useMap } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { toast } from "react-toastify";
import { apiURL, GetAll, Post, Put } from '../../../utils/apiCalls';
import { QRCodeSVG } from "qrcode.react";
import html2canvas from "html2canvas";
import DownloadIcon from '@mui/icons-material/Download';
import ShareIcon from '@mui/icons-material/Share';
import QrCodeIcon from '@mui/icons-material/QrCode';
import PaletteIcon from '@mui/icons-material/Palette';
import PrintIcon from '@mui/icons-material/Print';
import VisibilityIcon from '@mui/icons-material/Visibility';

const Myqr = () => {
  // const locations = [
  //   { name: "Chithapally", lat: 16.8005604, lng: 78.8240538, description: "Chithapally city of Telangana" },
  //   { name: "Arkapalle", lat: 16.8214207, lng: 78.7601995, description: "Arkapalle, Telangana 509327" },
  //   { name: "Pulumamidi", lat: 17.065664, lng: 78.4188783, description: "Pulumamidi, Telangana 501359" },
  //   { name: "Cheemala Kondur", lat: 17.5178802, lng: 79.0089976, description: "Cheemala Kondur" }
  // ];

const [locations, setLocations] = useState([]);
const [qrSize, setQrSize] = useState(200);
const [qrColor, setQrColor] = useState('#1976d2');
const [bgColor, setBgColor] = useState('#ffffff');
const [isLoading, setIsLoading] = useState(false);
//  const [userData, setUserData] = useState(null);

async function GetList () {
  const response = await GetAll(apiURL + '/api/v1/map_project_locations?is_active=true');
       if(response) {
      if (response.data.status) {       
        setLocations(response.data.data)
      }
      else {
      toast.error(response.data.message)
      setLocations({}) 
      }
    }
    else {
    }
};
useEffect(()=> {
  GetList()
},[]);

  const qrCodeRef = useRef();

  const handleDownload = () => {
    setIsLoading(true);
    html2canvas(qrCodeRef.current, {
      width: 400,
      height: 400,
      scale: 2,
      backgroundColor: bgColor,
      useCORS: true
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const a = document.createElement("a");
      a.href = imgData;
      a.download = `my-qr-code-${Date.now()}.png`;
      a.click();
      setIsLoading(false);
      toast.success('QR Code downloaded successfully!');
    }).catch((error) => {
      setIsLoading(false);
      toast.error('Failed to download QR Code');
    });
  };

  const userDetails = JSON.parse(sessionStorage.getItem('user_details'));
  const qrValue = `https://perfectlayout.in/#/AgentCreate/${userDetails?.qr || ''}`;

  const handleShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'My QR Code',
          text: 'Check out my QR Code',
          url: qrValue
        });
      } catch (error) {
        console.log('Error sharing:', error);
      }
    } else {
      // Fallback: copy to clipboard
      navigator.clipboard.writeText(qrValue);
      toast.success('Link copied to clipboard!');
    }
  };

  const handlePrint = () => {
    window.print();
  };

  console.log(qrValue, "qrValue")
  return (
    <div style={{ padding: '20px' }}>  
      {/* Header Section */}
      <Fade in timeout={800}>
        <Box sx={{ mb: 4 }}>
          <Stack direction="row" alignItems="center" spacing={2} sx={{ mb: 2 }}>
            <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                <QrCodeIcon sx={{ fontSize: 24 }} />
              </Box>
            </Avatar>
            <Box>
              <Typography variant="h5" component="h1" fontWeight="bold"  color="text.primary">
                My QR Code
              </Typography>
              <Typography variant="subtitle2" color="text.secondary">
                Share your profile with associates
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
        </Box>
      </Fade>

      <Grid container spacing={4}>
        {/* QR Code Display Section */}
        <Grid item xs={12} md={6}>
          <Zoom in timeout={1000}>
            <Card 
              elevation={8}
              sx={{ 
                borderRadius: 4,
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                color: 'white',
                overflow: 'hidden',
                position: 'relative'
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'rgba(255,255,255,0.1)',
                  backdropFilter: 'blur(10px)'
                }}
              />
              <CardContent sx={{ position: 'relative', zIndex: 1, p: 4 }}>
                <Stack alignItems="center" spacing={3}>
                  <Typography variant="h5" fontWeight="bold" textAlign="center">
                    Your Personal QR Code
                  </Typography>
                  
                  <Box
                    ref={qrCodeRef}
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      backgroundColor: 'white',
                      boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                      position: 'relative',
                      overflow: 'hidden'
                    }}
                  >
                    <Box
                      sx={{
                        position: 'absolute',
                        top: -50,
                        right: -50,
                        width: 100,
                        height: 100,
                        borderRadius: '50%',
                        background: 'linear-gradient(45deg, #ff6b6b, #4ecdc4)',
                        opacity: 0.1
                      }}
                    />
                    <Box sx={{ position: 'relative', zIndex: 1 }}>
                      <QRCodeSVG 
                        value={qrValue} 
                        size={qrSize} 
                        fgColor={qrColor}
                        bgColor={bgColor}
                        level="M"
                        includeMargin={true}
                      />
                    </Box>
                  </Box>

                  <Typography variant="body2" textAlign="center" sx={{ opacity: 0.9 }}>
                    Scan this QR code to connect with me
                  </Typography>

                  <Chip 
                    label="Active" 
                    color="success" 
                    variant="filled"
                    sx={{ 
                      fontWeight: 'bold',
                      '& .MuiChip-label': { px: 2 }
                    }}
                  />
                </Stack>
              </CardContent>
            </Card>
          </Zoom>
        </Grid>

        {/* Action Buttons Section */}
        <Grid item xs={12} md={6}>
          <Fade in timeout={1200}>
            <Stack spacing={3}>
              <Card elevation={4} sx={{ borderRadius: 3 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom fontWeight="bold">
                    Quick Actions
                  </Typography>
                  <Stack direction="row" spacing={2} flexWrap="wrap" useFlexGap>
                    <Tooltip title="Download as PNG">
                      <Button
                        variant="contained"
                        startIcon={<DownloadIcon />}
                        onClick={handleDownload}
                        disabled={isLoading}
                        sx={{ 
                          borderRadius: 2,
                          px: 3,
                          py: 1.5,
                          background: 'linear-gradient(45deg, #2196F3, #21CBF3)',
                          '&:hover': {
                            background: 'linear-gradient(45deg, #1976D2, #1CB5E0)',
                          }
                        }}
                      >
                        {isLoading ? 'Downloading...' : 'Download'}
                      </Button>
                    </Tooltip>

                    <Tooltip title="Share QR Code">
                      <Button
                        variant="outlined"
                        startIcon={<ShareIcon />}
                        onClick={handleShare}
                        sx={{ 
                          borderRadius: 2,
                          px: 3,
                          py: 1.5,
                          borderColor: 'primary.main',
                          color: 'primary.main',
                          '&:hover': {
                            borderColor: 'primary.dark',
                            backgroundColor: 'primary.50'
                          }
                        }}
                      >
                        Share
                      </Button>
                    </Tooltip>

                    <Tooltip title="Print QR Code">
                      <Button
                        variant="outlined"
                        startIcon={<PrintIcon />}
                        onClick={handlePrint}
                        sx={{ 
                          borderRadius: 2,
                          px: 3,
                          py: 1.5,
                          borderColor: 'secondary.main',
                          color: 'secondary.main',
                          '&:hover': {
                            borderColor: 'secondary.dark',
                            backgroundColor: 'secondary.50'
                          }
                        }}
                      >
                        Print
                      </Button>
                    </Tooltip>
                  </Stack>
                </CardContent>
              </Card>

              {/* Customization Options */}
              <Card elevation={4} sx={{ borderRadius: 3 }}>
                <CardContent sx={{ p: 3 }}>
                  <Typography variant="h6" gutterBottom fontWeight="bold">
                    Customize QR Code
                  </Typography>
                  <Stack spacing={3}>
                    <Box>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        Size: {qrSize}px
                      </Typography>
                      <input
                        type="range"
                        min="150"
                        max="300"
                        value={qrSize}
                        onChange={(e) => setQrSize(parseInt(e.target.value))}
                        style={{ width: '100%' }}
                      />
                    </Box>
                    
                    <Box>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        QR Color
                      </Typography>
                      <Stack direction="row" spacing={1}>
                        {['#1976d2', '#d32f2f', '#388e3c', '#f57c00', '#7b1fa2'].map((color) => (
                          <Box
                            key={color}
                            onClick={() => setQrColor(color)}
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: '50%',
                              backgroundColor: color,
                              cursor: 'pointer',
                              border: qrColor === color ? '3px solid #000' : '2px solid transparent',
                              transition: 'all 0.2s ease'
                            }}
                          />
                        ))}
                      </Stack>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>

              {/* Stats Card */}
              <Card elevation={4} sx={{ borderRadius: 3, background: 'linear-gradient(135deg, #ffecd2 0%, #fcb69f 100%)' }}>
                <CardContent sx={{ p: 3 }}>
                  <Stack direction="row" alignItems="center" spacing={2}>
                    <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.2)' }}>
                      <VisibilityIcon />
                    </Avatar>
                    <Box>
                      <Typography variant="h6" fontWeight="bold" color="white">
                        QR Code Stats
                      </Typography>
                      <Typography variant="body2" color="white" sx={{ opacity: 0.9 }}>
                        Ready to share with your network
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Stack>
          </Fade>
        </Grid>
      </Grid>

      {/* Loading Overlay */}
      {isLoading && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999
          }}
        >
          <Card sx={{ p: 3, borderRadius: 3 }}>
            <Stack alignItems="center" spacing={2}>
              <Typography variant="h6">Generating QR Code...</Typography>
              <LinearProgress sx={{ width: 200 }} />
            </Stack>
          </Card>
        </Box>
      )}
    </div>
  );
};

export default Myqr;
